export const GET_PRODUCT_ORDERS = "GET_PRODUCT_ORDERS"
export const GET_PRODUCT_ORDERS_SUCCESS = "GET_PRODUCT_ORDERS_SUCCESS"
export const GET_PRODUCT_ORDERS_FAILED = "GET_PRODUCT_ORDERS_FAILED"

export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAILED = "GET_PRODUCTS_FAILED"

export const GET_STRIPE_PRODUCTS = "GET_STRIPE_PRODUCTS"
export const GET_STRIPE_PRODUCTS_SUCCESS = "GET_STRIPE_PRODUCTS_SUCCESS"
export const GET_STRIPE_PRODUCTS_FAILED = "GET_STRIPE_PRODUCTS_FAILED"

export const GET_STRIPE_PRICES = "GET_STRIPE_PRICES"
export const GET_STRIPE_PRICES_SUCCESS = "GET_STRIPE_PRICES_SUCCESS"
export const GET_STRIPE_PRICES_FAILED = "GET_STRIPE_PRICES_FAILED"
export const RESET_STRIPE_PRICES = "RESET_STRIPE_PRICES"

export const CREATE_PRODUCT = "CREATE_PRODUCT"
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS"
export const CREATE_PRODUCT_FAILED = "CREATE_PRODUCT_FAILED"

export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_FAILED = "DELETE_PRODUCT_FAILED"
export const OPEN_DELETE_PRODUCT_MODAL = "OPEN_DELETE_PRODUCT_MODAL"
export const HIDE_DELETE_PRODUCT_MODAL = "HIDE_DELETE_PRODUCT_MODAL"

export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS"
export const GET_PRODUCT_FAILED = "GET_PRODUCT_FAILED"
export const RESET_PRODUCT = "RESET_PRODUCT"

export const GET_FEATURE_RECIPIENTS = "GET_FEATURE_RECIPIENTS"
export const GET_FEATURE_RECIPIENTS_SUCCESS = "GET_FEATURE_RECIPIENTS_SUCCESS"
export const GET_FEATURE_RECIPIENTS_FAILED = "GET_FEATURE_RECIPIENTS_FAILED"
export const RESET_FEATURE_RECIPIENTS = "RESET_FEATURE_RECIPIENTS"

export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAILED = "UPDATE_PRODUCT_FAILED"

export const CREATE_PRODUCT_CATEGORY = "CREATE_PRODUCT_CATEGORY"
export const CREATE_PRODUCT_CATEGORY_SUCCESS = "CREATE_PRODUCT_CATEGORY_SUCCESS"
export const CREATE_PRODUCT_CATEGORY_FAILED = "CREATE_PRODUCT_CATEGORY_FAILED"
export const RESET_PRODUCT_CATEGORY = "RESET_PRODUCT_CATEGORY"

export const UPDATE_PRODUCT_CATEGORY = "UPDATE_PRODUCT_CATEGORY"
export const UPDATE_PRODUCT_CATEGORY_SUCCESS = "UPDATE_PRODUCT_CATEGORY_SUCCESS"
export const UPDATE_PRODUCT_CATEGORY_FAILED = "UPDATE_PRODUCT_CATEGORY_FAILED"

export const GET_PRODUCT_CATEGORY = "GET_PRODUCT_CATEGORY"
export const GET_PRODUCT_CATEGORY_SUCCESS = "GET_PRODUCT_CATEGORY_SUCCESS"
export const GET_PRODUCT_CATEGORY_FAILED = "GET_PRODUCT_CATEGORY_FAILED"

export const GET_ORDER_DETAILS = "GET_ORDER_DETAILS"
export const GET_ORDER_DETAILS_SUCCESS = "GET_ORDER_DETAILS_SUCCESS"
export const GET_ORDER_DETAILS_FAILED = "GET_ORDER_DETAILS_FAILED"
export const RESET_ORDER_DETAILS = "RESET_ORDER_DETAILS"

export const GET_CATEGORY_FOR_FORM = "GET_CATEGORY_FOR_FORM"
export const GET_CATEGORY_FOR_FORM_SUCCESS = "GET_CATEGORY_FOR_FORM_SUCCESS"
export const GET_CATEGORY_FOR_FORM_FAILED = "GET_CATEGORY_FOR_FORM_FAILED"
export const RESET_CATEGORY_FOR_FORM = "RESET_CATEGORY_FOR_FORM"

export const GET_TEASER_PRODUCTS = "GET_TEASER_PRODUCTS"
export const GET_TEASER_PRODUCTS_SUCCESS = "GET_TEASER_PRODUCTS_SUCCESS"
export const GET_TEASER_PRODUCTS_FAILED = "GET_TEASER_PRODUCTS_FAILED"
export const RESET_TEASER_PRODUCTS = "RESET_TEASER_PRODUCTS"

export const SUBMIT_ORDER_FORM = "SUBMIT_ORDER_FORM"
export const SUBMIT_ORDER_FORM_SUCCESS = "SUBMIT_ORDER_FORM_SUCCESS"
export const SUBMIT_ORDER_FORM_FAILED = "SUBMIT_ORDER_FORM_FAILED"

export const GET_ORDER = "GET_ORDER"
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS"
export const GET_ORDER_FAILED = "GET_ORDER_FAILED"
export const RESET_ORDER = "RESET_ORDER"

export const GET_PRODUCT_USER_TAGS = "GET_PRODUCT_USER_TAGS"
export const GET_PRODUCT_USER_TAGS_SUCCESS = "GET_PRODUCT_USER_TAGS_SUCCESS"
export const GET_PRODUCT_USER_TAGS_FAILED = "GET_PRODUCT_USER_TAGS_FAILED"
export const RESET_PRODUCT_USER_TAGS = "RESET_PRODUCT_USER_TAGS"

export const SET_ORDER_CHECKOUT_SESSION = "SET_ORDER_CHECKOUT_SESSION"

export const OPEN_CLONE_PRODUCT_MODAL = "OPEN_CLONE_PRODUCT_MODAL"
export const HIDE_CLONE_PRODUCT_MODAL = "HIDE_CLONE_PRODUCT_MODAL"
export const CLONE_PRODUCT = "CLONE_PRODUCT"
export const CLONE_PRODUCT_SUCCESS = "CLONE_PRODUCT_SUCCESS"
export const CLONE_PRODUCT_FAILED = "CLONE_PRODUCT_FAILED"
